// localStorage keys starting with this prefix only live while the user is authenticated: they are cleared on logout
export const SESSION_LOCAL_STORAGE_PREFIX = 'nemuru_session_';

export const clearSessionLocalStorage = () => {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(SESSION_LOCAL_STORAGE_PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  } catch (err) {
    if (err instanceof DOMException) {
      console.warn('Local storage write-access restricted');
      console.warn('Failed to clearSessionLocalStorage');
      return;
    }
    throw err;
  }
};
